import React from 'react';
import { useState } from 'react';
import { Box} from '@mui/material';
import { postNewInspectorHQCompany } from '../../Services/InspectorAPI';
import AddCompanyForm from '../../../Components/Companies/AddCompanyForm';
import SnackBar from '../../../Components/SnackBar';
import AddCompanyDialogeBox from '../../../Components/Companies/DialogeBoxes/AddCompanyDialogeBox';
import LoadingBackDrop from '../../../Components/LoadingBackDrop';


// NEED TO ADD ERROR HANDLER HERE WHERE IF THE ITEM IS NOT ADDED IT IS NOT ADDED TO ARRAY AND NO FORM RESET.

export default function AddInspectingAgencyHQForm() {

  let hqBusinessType = "Inspector";

  const [confirmationDialogeBoxOpen, setConfirmationDialogeBoxOpen] = useState(false);
  const [openLoadingBackDrop, setOpenLoadingBackdrop] = useState(false);

  /**
   * SNACK BAR CONTROLS
   */
  const[alertType,setAlertType] = useState("success");
  const[alertMessage, setAlertMessage]=useState("")
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  

  const [companyObjct, setCompanyObjct] = useState({
      hq_company_name:"",
      hq_company_type:"Inspection",
      hq_company_address:{
        address:"",
        address_two:"",
        city:"",
        state:"",
        zip:""
    },
      hq_phone:"",
      hq_email:"",
      last_updated:""
  });

  const [errorObject,setErrorObject] = useState({
    hq_company_name:false,
    hq_company_type:"Bank",
    hq_company_address:{
      address:false,
      address_two:false,
      city:false,
      state:false,
      zip:false
  },
    hq_phone:false,
    hq_email:false
  
  })

  var initialCompanyObject = {
    hq_company_name:"",
    hq_company_type:"Bank",
    hq_company_address:{
      address:"",
      address_two:"",
      city:"",
      state:"",
      zip:""
  },
    hq_phone:"",
    hq_email:"",
    last_updated:""
  };

  function handleConfirmDialogeBoxClose(){
    setConfirmationDialogeBoxOpen(false);
  };

  function handleLoadingClose(){
    setOpenLoadingBackdrop(false);
  };


  /**
   * OPENS THE SNACKBAR
   */
    const handleSnackBarOpen = () => {
      setSnackBarOpen(true);
    };
  
    /**
     * CLOSES THE SNACK BAR
     */
    const handleSnackBarClosed = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setSnackBarOpen(false);
    };

     
    
  function handleNameChange(e){
    if(errorObject.hq_company_name === true && (e.target.value !== "" || e.target.value !== null) ){
      setErrorObject({
        ...errorObject,
        hq_company_name: false
      });
    }
    setCompanyObjct({
      ...companyObjct,
      hq_company_name: e.target.value
    });
  };
  
  function handleEmailChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_email: e.target.value
    });
  };
  
  function handlePhoneChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_phone: e.target.value
    });
  };
  
  function handleAddressChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_company_address:{
        ...companyObjct.hq_company_address,
        address:e.target.value
      }
    });
  };
  
  
  function handleAddressTwoChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_company_address:{
        ...companyObjct.hq_company_address,
        address_two:e.target.value
      }
    });
  };
  
  function handleCityChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_company_address:{
        ...companyObjct.hq_company_address,
        city:e.target.value
      }
    });
  };
  
  function handleStateChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_company_address:{
        ...companyObjct.hq_company_address,
        state:e.index
      }
    });
  };
  
  function handleZipChange(e){
    setCompanyObjct({
      ...companyObjct,
      hq_company_address:{
        ...companyObjct.hq_company_address,
        zip:e.target.value
      }
    });
  };

  /**
   * Error Validating The Form
   */
  function formErrorValidation(e){
    e.preventDefault();
    let foundError = false;

    if(companyObjct.hq_company_name === "" || companyObjct.hq_company_name === null ){
      setErrorObject({
        ...errorObject,
        hq_company_name:true
      });
      foundError = true;
    }



    if(!foundError){
      testConfirmAddCompanyConfirmationBox()
    }
  }
    
  /***
   * Handles the submit button from form component
   */
  function testConfirmAddCompanyConfirmationBox(){
    // e.preventDefault();
    setConfirmationDialogeBoxOpen(true)
  }
    
  /***
   * Handles the response from the confirmation dialoge box
   */
  function dialogeConfirmationBoxAnswerHandle(resp){
    console.log("handling answer");
    console.log("The answer is === " + resp);
    if(resp === "Agree"){
      setConfirmationDialogeBoxOpen(false);
      setOpenLoadingBackdrop(true);
      submitNewHQCompany();
    }else{
      setConfirmationDialogeBoxOpen(false);
    }
  }

  /***
   * Handles adding a new hq company
   */
  async function submitNewHQCompany(){
    let resp = await postNewInspectorHQCompany(companyObjct);
    if (resp.error){
      setAlertType("error");
      setAlertMessage("There was an error adding the HQ Inspector.");
    }else{
      setAlertType("success");
      setAlertMessage("The HQ Inspector has been successfully added.");
      handleSnackBarOpen();
      clearForm();
    }
    
  };

  function clearForm(){
    setCompanyObjct(initialCompanyObject);
    setOpenLoadingBackdrop(false);
  };

  return (
    <Box>
         <AddCompanyForm
          errorValidator={errorObject}
          addWhatCompanyTitle={hqBusinessType}
          hqCompanyObject={companyObjct}
          handleNameChange={handleNameChange}
          handleEmailChange={handleEmailChange}
          handlePhoneChange={handlePhoneChange}
          handleAddressChange={handleAddressChange}
          handleAddressTwoChange={handleAddressTwoChange}
          handleCityChange={handleCityChange}
          handleStateChange={handleStateChange}
          handleZipChange={handleZipChange}
          submitNewHqCompany={formErrorValidation}
        />
        <AddCompanyDialogeBox 
          addWhatCompanyType={hqBusinessType}
          hqCompanyObject={companyObjct}
          confirmationDialogeBoxOpen={confirmationDialogeBoxOpen}
          dialogeConfirmationBoxAnswerHandle={dialogeConfirmationBoxAnswerHandle}
          handleConfirmDialogeBoxClose={handleConfirmDialogeBoxClose}
        />
        <LoadingBackDrop
          openLoadingBackDrop={openLoadingBackDrop}
          handleLoadingClose={handleLoadingClose}
        />
        <SnackBar
          handleSanckBarOpen={handleSnackBarOpen}
          handleSnackBarClosed={handleSnackBarClosed}
          snackBarState = {snackBarOpen}
          alertType={alertType}
          alertMessage={alertMessage}
        />
    </Box>
  )
}


